import React, { useCallback } from "react";
import { WizardData } from "./OfferWizard";
import AccommodationFullscreen from "../accommodation-fullscreen/AccommodationFullscreen";

interface AccommodationStepProps {
  data: WizardData;
  updateData: (data: Partial<WizardData>) => void;
  onNext: () => void;
  onPrev: () => void;
}

const AccommodationStep: React.FC<AccommodationStepProps> = ({
  data,
  updateData,
  onNext,
  onPrev,
}) => {
  const handleOfferDaysChanged = useCallback(
    (offerDays: any[]) => {
      updateData({ offerDays });
    },
    [updateData]
  );
  if (!data.offerId) {
    return (
      <div className="text-center py-8">
        <p className="text-neutral-600">
          Brak ID oferty - nie można załadować noclegów.
        </p>
        <div className="flex justify-between pt-6">
          <button onClick={onPrev} className="btn-secondary">
            Wstecz
          </button>
          <button onClick={onNext} className="btn-primary">
            Dalej - Plan Pobytu
          </button>
        </div>
      </div>
    );
  }

  // Przygotuj dane dla nowego komponentu
  const accommodationDays = data.offerDays?.slice(0, -1) || [];
  const guestStructure = {
    pairs: accommodationDays[0]?.pairs || 0,
    singles: accommodationDays[0]?.singles || 0,
    singlesAlone: accommodationDays[0]?.singlesAlone || 0,
  };

  const markup =
    data.accommodationMarkupType && data.accommodationMarkupValue
      ? {
          accommodationMarkupType: data.accommodationMarkupType,
          accommodationMarkupValue: data.accommodationMarkupValue,
        }
      : undefined;

  return (
    <div className="space-y-6">
      {/* Nowy komponent na pełny ekran */}
      <AccommodationFullscreen
        offerId={data.offerId}
        initialData={{
          accommodationDays: data.offerDays,
          guestStructure,
          markup,
        }}
        onOfferDaysChanged={handleOfferDaysChanged}
      />

      {/* Nawigacja wizard-a */}
      <div className="flex justify-between pt-6 border-t border-gray-200">
        <button onClick={onPrev} className="btn-secondary">
          Wstecz
        </button>
        <button onClick={onNext} className="btn-primary">
          Dalej - Plan Pobytu
        </button>
      </div>
    </div>
  );
};

export default AccommodationStep;
